import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=14b1f2a7&"
import script from "./MainList.vue?vue&type=script&lang=js&"
export * from "./MainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14b1f2a7')) {
      api.createRecord('14b1f2a7', component.options)
    } else {
      api.reload('14b1f2a7', component.options)
    }
    module.hot.accept("./MainList.vue?vue&type=template&id=14b1f2a7&", function () {
      api.rerender('14b1f2a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainList.vue"
export default component.exports